import React, { useState } from 'react';
import classes from './LoginContent.module.scss';
import loginImage from '../../media/images/loginImage.png';
import useInput from "../../hooks/use-inputs";
import useAuth from "../../hooks/use-Auth";
import { useSnackbar } from 'notistack'
import { Link } from 'react-router-dom';



const LoginContent = () => {

  const { sendLoginRequest } = useAuth();
  const { enqueueSnackbar } = useSnackbar()
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

    const {
        value: enteredEmail,
        valueIsValid: enterEmailIsValid,
        hasError: emailInputIsInvalid,
        inputChangeHandler: emailInputChangeHandler,
        inputBlurHandler: emailInputBlurHandler,
        reset: resetEmail,
      } = useInput((value) => value.trim() !== "" && value.includes("@"));

      const {
        value: enteredPassword,
        valueIsValid: enteredPasswordIsValid,
        hasError: passwordInputIsInvalid,
        inputChangeHandler: passwordInputChangeHandler,
        inputBlurHandler: passwordInputBlurHandler,
        reset: resetPassword,
      } = useInput((value) => value.trim() !== "" && value.length >= 6);

 //Form Validation
  let submitFormValid = false;
  if (enterEmailIsValid && enteredPasswordIsValid) {
    submitFormValid = true;
  }

  const submitHandler = async (event) => {
    event.preventDefault();
    if (!submitFormValid || isSubmitting) return;

    setIsSubmitting(true);
    try {
      console.log("Attempting login with:", enteredEmail, "Remember me:", rememberMe);
      // Normalize email to lowercase before sending to backend
      const response = await sendLoginRequest({
        email: enteredEmail.toLowerCase(), 
        password: enteredPassword,
        rememberMe: rememberMe
      });
      
      if(response?.status === 200){
        displaySnackbar("Logged in successfully", "success");
        resetForm();
        
        // No need to do anything else - the Login component will handle redirection
        // based on the updated auth context
      } else if (response?.code === 404) {
        displaySnackbar(response.message || "Invalid email or password", "error");
      } else {
        displaySnackbar(response?.message || "Login failed, please try again", "error");
      }
    } catch (error) {
      console.error("Login error:", error);
      displaySnackbar("An error occurred during login. Please try again.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const displaySnackbar = (message, variant) => {
    enqueueSnackbar(message, {
      variant,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });
  };

  const resetForm = () => {
    resetEmail();
    resetPassword();
  };


  const formInputClasses = !submitFormValid
    ? `${classes.submit} ${classes.formInvalid} purpleLightBtn`
    : `${classes.submit} purpleLightBtn`;

    return (
        <div className={classes.LoginContainer}>
        <div className={classes.leftSideContainer}>
            <img src={loginImage} alt="login"/>
        </div>
        <div className={classes.rightSideContainer}>
        <div className={classes.formContainer}>
        <form onSubmit={submitHandler} className={classes.form}>
        <div className={classes.logo}>
            <img src="/logo512.png" alt="logo" />
        </div>
        <h1 className={classes.title}>Welcome back</h1>
        <h3 className={classes.subtitle}>Sign in to access your account</h3>
        <div className={classes.box}>
          <div className={classes.emailContainer}>
            <label htmlFor="email">Email </label>
            <input
              id="email"
              type="email"
              placeholder='Enter your email'
              value={enteredEmail}
              onChange={emailInputChangeHandler}
              onBlur={emailInputBlurHandler}
            />
              <p className={`${classes.invalid} ${emailInputIsInvalid ? `${classes.isVisible}` : ''}`}>
                          Enter Valid Email
              </p>
          </div>
          <div className={classes.passwordContainer}>
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder='Enter your password'
              value={enteredPassword}
              onChange={passwordInputChangeHandler}
              onBlur={passwordInputBlurHandler}
            />
              <p className={`${classes.invalid} ${passwordInputIsInvalid ? `${classes.isVisible}` : ''}`}>
                Enter a valid password
              </p>
          </div>
          <div className={classes.forgotPassword}>
            <div className={classes.checkbox}>
                <input 
                  type="checkbox" 
                  id="remember" 
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <label htmlFor="remember">Remember for 30 days</label>
            </div>
            <div className={classes.forgot}>
                <a href="/forgot-password">Forgot Password</a>
            </div>
            </div>
          <button 
            disabled={!submitFormValid || isSubmitting} 
            className={`${formInputClasses} ${classes.signInBtn}`}
          >
            {isSubmitting ? 'Signing In...' : 'Sign In'}
          </button>
          <div className={classes.createAccountDivider}>
            <div className={classes.divider}></div>
            <div className={classes.dividerText}>or</div>
            <div className={classes.divider}></div>
          </div>
          <Link to="/register" className={`${classes.createNewAccount}`}>
            Create new account
          </Link>
        </div>
      </form>
            </div>
            <div className={classes.bottomText}>
            © Copyright {new Date().getFullYear()} All Rights Reserved Magic Motorsports
            </div> 
        </div>
        </div>
    )
}

export default LoginContent;